<template>
  <div class="page">
    <van-nav-bar title="客户榜单详情" left-text="返回" left-arrow @click-left="$router.back()"/>

    <div class="rank-card" v-if="showCount">
      <h4>客户数量排名</h4>
      <table>
        <thead>
        <tr>
          <th>排名</th>
          <th>姓名</th>
          <th>总量</th>
          <th>S级</th>
          <th>A级</th>
          <th>B级</th>
          <th>C级</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="r in ownerCountAll" :key="'oc'+r.rank">
          <td><span class="medal" v-if="r.rank<=3">🏅</span><span v-else>{{ r.rank }}</span></td>
          <td>{{ r.name }}</td>
          <td class="num">{{ r.count }}</td>
          <td class="num">{{ r.s }}</td>
          <td class="num">{{ r.a }}</td>
          <td class="num">{{ r.b }}</td>
          <td class="num">{{ r.c }}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="rank-card" v-if="showValue">
      <h4>客户价值排名</h4>
      <table>
        <thead>
        <tr>
          <th>排名</th>
          <th>姓名</th>
          <th>价值(元)</th>
          <th>S级</th>
          <th>A级</th>
          <th>B级</th>
          <th>C级</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="r in ownerValueAll" :key="'ov'+r.rank">
          <td><span class="medal" v-if="r.rank<=3">🏅</span><span v-else>{{ r.rank }}</span></td>
          <td>{{ r.name }}</td>
          <td class="num">{{ Number(r.value || 0).toFixed(2) }}</td>
          <td class="num">{{ r.s }}</td>
          <td class="num">{{ r.a }}</td>
          <td class="num">{{ r.b }}</td>
          <td class="num">{{ r.c }}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="rank-card" v-if="showCount">
      <h4>事业部客户数量排名</h4>
      <table>
        <thead>
        <tr>
          <th>排名</th>
          <th>名称</th>
          <th>总量</th>
          <th>S级</th>
          <th>A级</th>
          <th>B级</th>
          <th>C级</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="r in industryCountAll" :key="'ic'+r.rank">
          <td><span class="medal" v-if="r.rank<=3">🏅</span><span v-else>{{ r.rank }}</span></td>
          <td>{{ r.name }}</td>
          <td class="num">{{ r.count }}</td>
          <td class="num">{{ r.s }}</td>
          <td class="num">{{ r.a }}</td>
          <td class="num">{{ r.b }}</td>
          <td class="num">{{ r.c }}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="rank-card" v-if="showValue">
      <h4>事业部客户价值排名</h4>
      <table>
        <thead>
        <tr>
          <th>排名</th>
          <th>名称</th>
          <th>价值(元)</th>
          <th>S级</th>
          <th>A级</th>
          <th>B级</th>
          <th>C级</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="r in industryValueAll" :key="'iv'+r.rank">
          <td><span class="medal" v-if="r.rank<=3">🏅</span><span v-else>{{ r.rank }}</span></td>
          <td>{{ r.name }}</td>
          <td class="num">{{ Number(r.value || 0).toFixed(2) }}</td>
          <td class="num">{{ r.s }}</td>
          <td class="num">{{ r.a }}</td>
          <td class="num">{{ r.b }}</td>
          <td class="num">{{ r.c }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import coreapi from "@/utils/coreapi";

export default {
  name: "BossCustomerRank",
  data() {
    return {
      ownerCountAll: [],
      ownerValueAll: [],
      industryCountAll: [],
      industryValueAll: []
    };
  },
  mounted() {
    this.load();
  },
  computed: {
    showCount() {
      const t = this.$route.query.type;
      return !t || t === "count";
    },
    showValue() {
      const t = this.$route.query.type;
      return !t || t === "value";
    }
  },
  methods: {
    async load() {
      try {
        const d = await coreapi.bossCustomerData("rank");
        this.ownerCountAll = d.ownerCountAll || [];
        this.ownerValueAll = d.ownerValueAll || [];
        this.industryCountAll = d.industryCountAll || [];
        this.industryValueAll = d.industryValueAll || [];
      } catch (e) {
        console.error("加载客户榜单失败", e);
      }
    }
  }
};
</script>

<style scoped>
.page {
  padding: 12px;
  background: #f5f6f8;
  min-height: 100vh;
}

.rank-card {
  background: #fff8e6;
  border: 1px solid #d4af37;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
}

.rank-card h4 {
  text-align: center;
  font-size: 13px;
  color: #b88a3a;
  margin: 0 0 8px;
  background: #f5e6c5;
  padding: 6px 0;
  border-radius: 4px;
}

.rank-card table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.rank-card th {
  background: #f5e6c5;
  color: #b88a3a;
  padding: 6px 4px;
}

.rank-card td {
  padding: 8px 4px;
  text-align: center;
  border-top: 1px dashed #d4af37;
}

.rank-card td.num {
  color: #ee5b4f;
  font-weight: 600;
}

.rank-card .medal {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/boss/CustomerRank.vue